import { render } from "./righttBar.vue?vue&type=template&id=5afaad0a"
import script from "./righttBar.vue?vue&type=script&lang=js"
export * from "./righttBar.vue?vue&type=script&lang=js"

import "./righttBar.vue?vue&type=style&index=0&id=5afaad0a&lang=less"
script.render = render

export default script